export default axios => ({
  /**
   * Получение access и refresh токенов
   *
   * @param username
   * @param password
   * @returns {*}
   */
  login ({ username, password }) {
    return axios.post('/auth/v1/login', {
      username, password
    }, {
      headers: { auth: false }
    })
  },
  /**
   * Возвращает информацию о текущем профиле
   *
   * @returns {*}
   */
  me () {
    return axios.get('/web/profile/me')
  },
  /**
   * Запрос на смену пароля
   *
   * @param email
   * @returns {*}
   */
  reset (email) {
    return axios.post('/auth/v1/reset', {
      emailOrPhone: email
    }, {
      headers: { auth: false }
    })
  },
  /**
   * Сброс пароля (Доступен после /auth/v1/reset)
   *
   * @returns {*}
   */
  newPassword () {
    return axios.post('/auth/v1/password', {}, {
      headers: { auth: false }
    })
  },

  /**
   * Сброс access токена
   *
   * @param refreshToken
   * @returns {*}
   */
  refreshToken (refreshToken) {
    return axios.put('/auth/v1/refresh', {
      refreshToken
    }, {
      headers: { auth: false }
    })
  },
  /**
   * Изменяет пароль пользователя
   *
   * @param password
   * @param newPassword
   * @returns {*}
   */
  change ({ password, newPassword }) {
    return axios.put('/web/profile/password', {
      password, newPassword
    })
  }
})
